import 'core-js/stable'
import 'regenerator-runtime/runtime'
import MwcBasePlugin from '../packages/mwc-vue-shared/plugins/the-mwc-base-helper'
import MwcApplicationHelper from 'mwc-application-helper'
import wrap from '@vue/web-component-wrapper'
import WebComponentUsingVue from './components/LoginForm/mwcLoginPage.vue'

const Vue = window.Vue

MwcApplicationHelper.initializeMwc()
Vue.use(MwcBasePlugin)
Vue.config.ignoredElements = [
  'mds-button'
]

const CustomElement = wrap(Vue, WebComponentUsingVue)

window.customElements.define('mwc-login', CustomElement)
export default WebComponentUsingVue
